import { AdminLogEntry } from "./AdminLogEntry"

export class AdminLogFile {
  relativePath: string

  fileName: string

  lastWriteAtUtc: string

  fileSizeBytes: number

  isTruncated: boolean

  totalLines: number

  entries: AdminLogEntry[]

  constructor(data: Partial<AdminLogFile> = {}) {
    this.relativePath = data.relativePath ?? ""

    this.fileName = data.fileName ?? ""

    this.lastWriteAtUtc = data.lastWriteAtUtc ?? ""

    this.fileSizeBytes = data.fileSizeBytes ?? 0

    this.isTruncated = data.isTruncated ?? false

    this.totalLines = data.totalLines ?? 0

    this.entries = (data.entries ?? []).map((item) => new AdminLogEntry(item))
  }
}
